import { render, staticRenderFns } from "./CatchUp.vue?vue&type=template&id=2d864e6b&scoped=true&lang=html&"
import script from "./CatchUp.vue?vue&type=script&lang=js&"
export * from "./CatchUp.vue?vue&type=script&lang=js&"
import style0 from "./CatchUp.vue?vue&type=style&index=0&id=2d864e6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d864e6b",
  null
  
)

export default component.exports